var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12116_5438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 30.0406V168.96C111 176.964 99.9052 181.005 93.3468 175.388L45.8098 134.672C43.8689 133.01 41.2547 132.078 38.5305 132.078H10.3738C4.64436 132.078 0 128.039 0 123.056V76.629C0 71.6459 4.64436 67.6065 10.3738 67.6065H38.4828C41.235 67.6065 43.8741 66.6556 45.8202 64.9621L93.2898 23.6617C99.8243 17.9766 111 22.0015 111 30.0406Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.543 29.2036C161.874 28.5473 165.372 29.4982 167.581 31.7617C188.592 53.3034 199.619 76.4596 199.99 99.8941C200.361 123.284 190.107 146.462 169.854 168.093C167.654 170.443 164.094 171.455 160.686 170.809C153.619 169.467 150.745 161.999 154.913 156.863C169.714 138.623 177.163 119.371 176.855 99.9639C176.548 80.5234 168.464 61.286 153.035 43.1091C148.76 38.0717 151.516 30.5878 158.543 29.2036Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.017 55.6213C131.382 54.4077 135.275 54.9817 137.819 57.2585C152.005 69.9627 159.681 84.485 159.99 99.3473C160.298 114.165 153.271 128.732 139.699 141.574C137.182 143.954 133.226 144.609 129.776 143.423C123.326 141.208 121.673 133.842 125.703 128.911C133.247 119.678 137.089 109.651 136.878 99.4858C136.666 89.2664 132.362 79.234 124.353 70.0545C120.179 65.2695 121.654 57.9162 128.017 55.6213Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12116_5438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundFull);
export default __webpack_public_path__ + "static/media/soundFull.55b30c806ac03b9c76cf15ce46b7200b.svg";
export { ForwardRef as ReactComponent };